import React from "react";
import { motion } from "framer-motion";
import { HATS, HATS_INTRO } from "@/content";

function HatCard({ hat, index, offset }) {
  const tintBg =
    hat.key === "designer"
      ? "rgba(255,107,53,0.10)"
      : hat.key === "architect"
      ? "rgba(0,212,170,0.10)"
      : hat.key === "founder"
      ? "rgba(212,168,67,0.12)"
      : "rgba(0,102,255,0.09)";

  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-15% 0px -10% 0px" }}
      transition={{ duration: 0.9, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className={`relative rounded-[22px] p-8 md:p-12 border border-black/5 ${offset ? "md:translate-y-12" : ""}`}
      style={{ background: tintBg }}
      data-testid={`hat-card-${hat.key}`}
    >
      <div className="flex items-center gap-3 mb-6">
        <span
          className="inline-block w-2.5 h-2.5 rounded-full"
          style={{ background: hat.accent, boxShadow: `0 0 0 4px ${hat.accent}1A` }}
        />
        <span className="font-mono text-[10px] tracking-[0.24em] uppercase font-semibold text-ink">
          {hat.tag}
        </span>
      </div>

      <h3 className="font-serif italic text-[30px] md:text-[40px] lg:text-[46px] leading-[1.08] tracking-tight text-ink max-w-[18ch]">
        {hat.title}
      </h3>

      <p className="mt-6 text-[15px] md:text-[16px] text-ink/80 leading-[1.65] max-w-[52ch]">
        {hat.body}
      </p>

      {hat.tags && hat.tags.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2">
          {hat.tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1.5 rounded-full font-mono text-[10px] tracking-[0.18em] uppercase border border-black/12 text-ink/65 bg-white/60"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </motion.article>
  );
}

export default function Hats() {
  return (
    <section id="hats" className="relative py-24 md:py-36" data-testid="chapter-hats">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="mb-14 md:mb-20 max-w-[60ch]"
        >
          <div className="label-mono mb-5">02 — {HATS_INTRO.kicker}</div>
          <h2 className="font-serif text-[44px] md:text-[68px] lg:text-[88px] leading-[1.0] tracking-tight text-ink">
            {HATS_INTRO.title}
            <br />
            <span className="italic text-mute">{HATS_INTRO.titleEm}</span>
          </h2>
          <p className="mt-7 text-[16px] md:text-[18px] text-mute leading-[1.6] max-w-[58ch]">
            {HATS_INTRO.sub}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {HATS.map((hat, i) => (
            <HatCard hat={hat} key={hat.key} index={i} offset={i % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  );
}
